import { enUS, es, ptBR } from 'date-fns/locale'

const DATEPICKER_LOCALE_MAP = {
  'pt-br': { locale: ptBR, localeCode: 'pt-BR' },
  'en-us': { locale: enUS, localeCode: 'en-US' },
  'es-co': { locale: es, localeCode: 'es' }
}

export function getDatepickerLocaleConfig (appLocale = 'pt-br') {
  const normalizedLocale = String(appLocale).toLowerCase()
  return DATEPICKER_LOCALE_MAP[normalizedLocale] || DATEPICKER_LOCALE_MAP['pt-br']
}

export function isMonthPickerValueType (pickerType) {
  return pickerType === 'month'
}

export function toMonthPickerModel (value) {
  const date = normalizeDateValue(value)

  if (!date) return null

  return {
    month: date.getMonth(),
    year: date.getFullYear()
  }
}

export function fromMonthPickerModel (value) {
  if (!value || Array.isArray(value)) return null

  const month = Number(value.month)
  const year = Number(value.year)

  if (Number.isNaN(month) || Number.isNaN(year)) return null

  return new Date(year, month, 1)
}

export function normalizeDateValue (value) {
  if (!value) return null

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value
  }

  const normalizedDate = new Date(value)

  return Number.isNaN(normalizedDate.getTime()) ? null : normalizedDate
}
